exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pix-checkbox {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  width: 100%;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.pix-checkbox__label {\r\n  word-break: break-word;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  line-height: 1.2;\r\n  color: #404040;\r\n  min-width: 20%;\r\n  margin-bottom: 0px;\r\n}\r\n", ""]);

// exports
